import { constants } from "../constant/constants";
import { HttpHelper } from "../helper/http-helper-service";
import { TicketPaginationValues } from "../model/ticket/ticket-pagination-values";

import PrototypeInstance from "../helper/prototype-instance";
import {
  applyClientPortalUnreadStateOnTicketSync,
  type TicketRecentCommentSnapshot,
} from "../entity-service/ticket-entity-service";
import { ticketEntity } from "../model/entity/ticket-entity";

export default class ticketService {
  static GetAllTickets(pagination: TicketPaginationValues) {
    return HttpHelper.postData(
      constants.apiUrl.ticketUrls.getAllTickets,
      pagination,
    );
  }

  static getTicketDetailByIdForSignalR(...params: any[]): Promise<any> {
    if (params[0] != null && params[1] != null) {
      return HttpHelper.getData(
        constants.apiUrl.ticketUrls.getTicketDetailById +
          "?TicketId=" +
          params[0] +
          "&signalRMessageTick=" +
          params[1],
      );
    } else {
      return HttpHelper.getData(
        constants.apiUrl.ticketUrls.getTicketDetailById +
          "?TicketId=" +
          params[0].ticketId +
          "&signalRMessageTick=" +
          params[0].tick,
      );
    }
  }

  static getTicketComments = (
    id: string,
    params: object,
    pageNumber: number,
    pageSize: number,
  ) => {
    let url =
      constants.apiUrl.ticketUrls.get +
      "/" +
      id +
      "?PageNumber=" +
      pageNumber +
      "&PageSize=" +
      pageSize +
      "";
    return HttpHelper.getData(url, params);
  };

  /** Path must include ticket id — matches gateway `comment/{id}/{ticketId}` (see ticket-api-service). */
  static getCommentByCommentId = (commentId: string, ticketId: string) => {
    return HttpHelper.getData(
      constants.apiUrl.ticketUrls.getCosmosCommentByCommentId +
        "/" +
        commentId +
        "/" +
        ticketId,
    );
  };

  static getCommentListByTick = (object: any) => {
    return HttpHelper.postData(
      constants.apiUrl.ticketUrls.getCommentListByTick,
      object,
    );
  };

  static async getTicketsByTick(object: any) {
    const result = await HttpHelper.postData(
      constants.apiUrl.ticketUrls.ticketbytick,
      object,
    );

    const tickets = result.tickets;
    if (!result.ticketsToDelete) {
      result.ticketsToDelete = [];
    }

    if (tickets != null) {
      const store = PrototypeInstance.globalProperties.$store;
      const selectedTicketId = store.getters[
        "ticketDetailModule/getTicketId"
      ] as string;
      const viewerContactId = store.getters[
        "ContactModule/getContactId"
      ] as number;
      const ticketToUpdate = tickets as any[];

      ticketToUpdate.forEach((ticket: any) => {
        const existing = ticketEntity.find(String(ticket.ticketId ?? ""));
        applyClientPortalUnreadStateOnTicketSync(
          ticket,
          selectedTicketId,
          existing?.isUnread,
          viewerContactId,
        );
      });

      return {
        tickets: ticketToUpdate,
        ticketsToDelete: result.ticketsToDelete.map(
          (ticket: any) => ticket.ticketId,
        ),
      };
    } else {
      return {
        tickets: tickets,
        ticketsToDelete: result.ticketsToDelete.map(
          (ticket: any) => ticket.ticketId,
        ),
      };
    }
  }

  static getTicketCosmosCommentById = (id: number, params: object) => {
    let url = constants.apiUrl.ticketUrls.getTicketCosmosCommentById + "/" + id;
    return HttpHelper.getData(url, params);
  };

  static saveTicketComment(dataModel: any) {
    return HttpHelper.postData(
      constants.apiUrl.ticketUrls.saveTicketComment,
      dataModel,
    );
  }

  static createEncryptedTextLink = (params: object) => {
    return HttpHelper.postData(
      constants.apiUrl.ticketUrls.createEncryptedTextLink,
      params,
    );
  };

  static getCommentListByFilter = (object: any) => {
    return HttpHelper.postData(
      constants.apiUrl.ticketUrls.getCommentListByFilter,
      object,
    );
  };

  /** Latest public comment visible to the logged-in contact (technician or own contact posts). */
  static getRecentCommentForCx = (ticketId: string) => {
    return HttpHelper.getData(
      constants.apiUrl.ticketUrls.getRecentCommentForCx + "/" + ticketId,
    ) as Promise<TicketRecentCommentSnapshot | null>;
  };

  static updateTicketComment(dataModel: any) {
    return HttpHelper.patchData(
      constants.apiUrl.ticketUrls.updateTicketComment,
      dataModel,
    );
  }

  static getCommentsByCommentIds = (object: any) => {
    return HttpHelper.postData(
      constants.apiUrl.ticketUrls.getCommentsByCommentIds,
      object,
    );
  };

  static getBlobSharedAccessSignature = (params: object) => {
    return HttpHelper.postData(
      constants.apiUrl.ticketUrls.getBlobSharedAccessSignature,
      params,
    );
  };

  static setCommentReaction = (params: object) => {
    return HttpHelper.postData(
      constants.apiUrl.ticketUrls.setCommentReaction,
      params,
    );
  };

  static UpdateTicketContacts(object: any) {
    const url = constants.apiUrl.ticketUrls.updateticketcontact;
    return HttpHelper.patchData(url, object);
  }

  static setCommentCCEmail = (params: object) => {
    return HttpHelper.postData(
      constants.apiUrl.ticketUrls.setCommentCCEmail,
      params,
    );
  };

  static showHideCommentById = (object: any) => {
    return HttpHelper.patchData(
      constants.apiUrl.ticketUrls.showHideCommentById,
      object,
    );
  };

  static async getServiceProviderAllTick() {
    return HttpHelper.getData(
      constants.apiUrl.ticketUrls.getServiceProviderTicketTick,
      null,
    );
  }

  static saveTicket(dataModel: any) {
    return HttpHelper.postData(
      constants.apiUrl.ticketUrls.saveTicket,
      dataModel,
    );
  }

  static async getClosedTicketsByDate(object: any) {
    const closedTickets = await HttpHelper.postData(
      constants.apiUrl.ticketUrls.getClosedTicketsByDate,
      object,
    );

    closedTickets.forEach((ticket: any) => {
      ticket.isUnread = false;
    });

    return closedTickets;
  }

  static getCustomStatus(dataModel: any) {
    return HttpHelper.getData(
      constants.apiUrl.ticketUrls.getCustomStatus,
      null,
    );
  }
}
